angular.module('bb.external').component('bbExternalAppointmentTimeChange', {
  bindings: {
    isListingContact: '<?',
  },
  controller: ExternalAppointmentTimeChangeController,
  controllerAs: 'vm',
  template: `<appointment-book
                ng-if="vm.appointment && (vm.auth.retsDashboard || vm.auth.coopDashboard || vm.auth.externalDashboard)"
                appointment-details="vm.appointment"
                is-time-change="true"
                is-listing-contact="vm.isListingContact"
                ext-auth="vm.auth"/>
              `,
});

ExternalAppointmentTimeChangeController.$inject = [
  '$routeParams',
  'ExternalService',
  'ExternalAuth',
];

function ExternalAppointmentTimeChangeController(
  $routeParams,
  ExternalService,
  ExternalAuth,
) {
  const vm = this;
  vm.dashboard = true;
  vm.auth = ExternalAuth.auth;
  vm.$onInit = () => {
    vm.appointmentId = $routeParams.appointmentId;
    ExternalService.getAppointment(
      $routeParams.dashboardId,
      $routeParams.appointmentId,
    ).then(data => {
      vm.appointment = { listing: data.listing, appointment: data };
    });
  };
}

export {};
